import { render, staticRenderFns } from "./MenuSideCat.vue?vue&type=template&id=aeb653a8&scoped=true&"
import script from "./MenuSideCat.vue?vue&type=script&lang=js&"
export * from "./MenuSideCat.vue?vue&type=script&lang=js&"
import style0 from "./MenuSideCat.vue?vue&type=style&index=0&id=aeb653a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb653a8",
  null
  
)

export default component.exports